module.exports = __webpack_public_path__ + "img/yuangong04.a8f3fe03.jpg";